import { Core } from "@faire/design-tokens";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";

import { PerStyleVariationMapBuilder } from "@faire/retailer/features/OpenSizing/PerStyleVariationMapBuilder";

import { OpenSizingVariationHelper } from "./OpenSizingVariationHelper";
import { OpenSizingVariationInput } from "./OpenSizingVariationInput";
import { OpenSizingVariationLabel } from "./OpenSizingVariationLabel";

interface IProps {
  className?: string;
  onChange: (value: number) => void;
  isFirst?: boolean;
  variation: PerStyleVariationMapBuilder.IPerStyleOptionVariation;
}

/**
 * @trackcomponent
 * @supersededBy "@faire/web/slate/QuantityPicker/QuantityPicker#QuantityPicker"
 */
const QuantityPickerBase: React.FC<IProps> = ({
  variation,
  className,
  onChange,
  isFirst,
}) => {
  return (
    <Container className={className} $isFirst={isFirst}>
      <LabelContainer>
        <FullWidthColumn>
          <OpenSizingVariationLabel variation={variation} />
          <OpenSizingVariationHelper variation={variation} />
        </FullWidthColumn>
      </LabelContainer>
      <InputContainer>
        <OpenSizingVariationInput variation={variation} onChange={onChange} />
      </InputContainer>
    </Container>
  );
};

export const QuantityPicker = observer(QuantityPickerBase);

const Container = styled(Row).attrs({
  justify: "space-between",
  align: "center",
})<{ $isFirst?: boolean }>`
  width: 100%;
  padding: ${getSpacing(5, 0)};
  border: 1px solid ${Core.border.muted};
  margin-top: ${({ $isFirst }) => ($isFirst ? "unset" : "-1px")};
`;

const LabelContainer = styled(Row).attrs({
  align: "center",
})`
  width: 100%;
  margin-left: ${getSpacing("2x")};
  margin-right: ${getSpacing("2x")};
`;

const FullWidthColumn = styled(Column)`
  width: 100%;
`;

const InputContainer = styled(Row).attrs({
  justify: "flex-end",
  align: "center",
})`
  margin-right: ${getSpacing("2x")};
  width: 140px;

  ${responsiveMediaQueries.mobile} {
    width: 150px;
  }
`;
